export default {"src":"/_next/static/media/business5.b332eddb.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};